import { FC, useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "stores";
import { useParams } from "react-router";
import store from "stores/interfaces";
import CharacterStatusItem from "containers/CharacterStatusItem";
import styled from "styled-components";
import { Typography } from "@mui/material";

const RoomCharacter: FC = () => {
  const { roomId, characterId } = useParams<{
    roomId: string;
    characterId: string;
  }>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    document.body.className = "transparent";
    return () => {
      document.body.className = "";
    };
  }, []);

  const [isNotfound, setIsNotfound] = useState(false);
  const onNotfound = useCallback(() => {
    setIsNotfound(true);
  }, [setIsNotfound]);

  useEffect(() => {
    return dispatch(
      store.subscribeRoomCharacter({ roomId, characterId }, onNotfound)
    );
  }, [roomId, characterId, dispatch, onNotfound]);

  if (isNotfound) {
    return (
      <Container>
        <Typography>コマが見つかりませんでした</Typography>
      </Container>
    );
  }

  return (
    <Container>
      <CharacterStatusItem
        characterId={characterId}
        variant="bar"
        onClick={console.log}
      />
    </Container>
  );
};

const Container = styled.div`
  padding: 8px;
`;

export default RoomCharacter;
